/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Campus_3Inputs */

const en_gd_campus_3 = /** @type {(inputs: Gd_Campus_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The result goes into the class gallery — a portfolio piece to show, not homework that gathers dust.`)
};

const id_gd_campus_3 = /** @type {(inputs: Gd_Campus_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasilnya masuk galeri kelas — jadi portofolio yang bisa ditunjukkan, bukan tugas yang mengendap.`)
};

/**
* | output |
* | --- |
* | "The result goes into the class gallery — a portfolio piece to show, not homework that gathers dust." |
*
* @param {Gd_Campus_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_campus_3 = /** @type {((inputs?: Gd_Campus_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Campus_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_campus_3(inputs)
	return en_gd_campus_3(inputs)
});